<template>
	<Hat class="screen-start section section--mini home-header">
		<div class="home-header__in">
			<div class="home-header__head">
				<p class="home-header__title">Total Balance</p>
				<p class="home-header__balance" data-currency="USDT">{{ me.balance.toFixed(2) }}</p>
			</div>
			<div class="home-header__footer">
				<Button color="brand" size="small" :is="RouterLink" to="/wallet/top-up">
					<Icon name="plus" :size="1.25" /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Top up
				</Button>
				<Button color="light" size="small" :is="RouterLink" to="/wallet/withdrawal">
					<Icon name="up" /> Withdraw
				</Button>
			</div>
		</div>
		<div class="home-header__referals">
			<span class="home-header__referrals-profit" data-currency="USDT">{{referrals_profit.toFixed(2)}}</span>
			<p class="home-header__referrals-hint">Received by referrals</p>
		</div>
	</Hat>
	<section class="section section--mini" style="padding-left:0;">
		<AnalyticChart />
	</section>
	<section class="home-info section section--mini">
		<p class="home-info__row">
			<span class="home-info__title">Bot status:</span>
			<span class="home-info__value home-info__status" :class="{
				'home-info__status--active' : me.is_trading_enabled,
				'home-info__status--disabled' : !me.is_trading_enabled
			}">
				{{ me.is_trading_enabled ? 'Active' : 'Not active' }}
			</span>
		</p>
		<p class="home-info__row">
			<span class="home-info__title">Actual price:</span>
			<span class="home-info__value home-info__course" data-currency="USDT/BTC">{{ course.toFixed(2) }}</span>
		</p>
	</section>
	<section class="home-controls section section--mini">
		<Button color="brand-transparent" type="button" @click="start" :disabled="me.is_trading_enabled">
			<Icon name="rocket" /> Start
		</Button>
		<Button color="red-transparent" type="button" @click="stop" :disabled="!me.is_trading_enabled">
			<Icon name="close" :size="1.5" /> Stop
		</Button>
		<Button color="dark">
			<Icon name="support" /> Channel
		</Button>
		<Button color="dark">
			<Icon name="support" /> Chat
		</Button>
	</section>
</template>
<script lang="ts" setup>
import "./HomeView.scss";
import Hat from "@/components/Hat/Hat.vue";
import Button from "@/components/Button/Button.vue";
import Icon from "@/components/Icon/Icon.vue";
import AnalyticChart from "@/components/AnalyticChart/AnalyticChart.vue";
import {RouterLink, useRouter} from "vue-router";
import {useUserStore} from "@/stores/userStore";
import {onMounted, ref} from "vue";
import {useApiStore} from "@/stores/apiStore";
import {storeToRefs} from "pinia";

let userStore = useUserStore();
let {api} = useApiStore();
let router = useRouter();

let {me} = storeToRefs(userStore);

let course = ref<number>(0);
let referrals_profit = ref<number>(0);

async function start(){

	if(me.value!.balance > 0){
		await api.startTrading();
	}else{
		await router.push('/wallet/top-up');
	}

}

async function stop(){
	await api.stopTrading();
}

onMounted(async () => {
	course.value = +await api.getCourse();
	referrals_profit.value = (await api.getStatistic()).referrals.amount;
});

</script>